import __var_0__ from '@stdlib/array/complex128';
import __var_1__ from '@stdlib/utils/constructor-name';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var Complex128Array = __var_0__;
var constructorName = __var_1__;


// MAIN //

/**
* Tests if a value is a Complex128Array.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating whether value is a Complex128Array
*
* @example
* var bool = isComplex128Array( new Complex128Array( 10 ) );
* // returns true
*
* @example
* var bool = isComplex128Array( [] );
* // returns false
*/
function isComplex128Array( value ) {
	return (
		value instanceof Complex128Array ||
		constructorName( value ) === 'Complex128Array'
	);
}


// EXPORTS //
export default isComplex128Array;
